import ApiClient from './ApiClient';

class DisparosAPI extends ApiClient {
  constructor() {
    super('disparos', { accountScoped: true });
  }

  getCampaigns() {
    return axios.get(`${this.url}/campaigns`);
  }

  createCampaign(data) {
    return axios.post(`${this.url}/campaigns`, data);
  }

  showCampaign(id) {
    return axios.get(`${this.url}/campaigns/${id}`);
  }

  deleteCampaign(id) {
    return axios.delete(`${this.url}/campaigns/${id}`);
  }

  startCampaign(id) {
    return axios.post(`${this.url}/campaigns/${id}/start`);
  }

  pauseCampaign(id) {
    return axios.post(`${this.url}/campaigns/${id}/pause`);
  }

  resumeCampaign(id) {
    return axios.post(`${this.url}/campaigns/${id}/resume`);
  }

  stopCampaign(id) {
    return axios.post(`${this.url}/campaigns/${id}/stop`);
  }

  testCampaign(id, data) {
    return axios.post(`${this.url}/campaigns/${id}/test`, data);
  }

  testSend(data) {
    return axios.post(`${this.url}/campaigns/test_send`, data);
  }

  getCampaignLogs(id, params = {}) {
    return axios.get(`${this.url}/campaigns/${id}/logs`, { params });
  }

  getCampaignRealtime(id) {
    return axios.get(`${this.url}/campaigns/${id}/realtime`);
  }

  exportFailures(id) {
    return axios.get(`${this.url}/campaigns/${id}/export_failures`, {
      responseType: 'blob',
    });
  }

  getContactLists() {
    return axios.get(`${this.url}/contact_lists`);
  }

  uploadContactList(formData) {
    return axios.post(`${this.url}/contact_lists`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateMapping(id, mapping) {
    return axios.put(`${this.url}/contact_lists/${id}/mapping`, { mapping });
  }

  deleteContactList(id) {
    return axios.delete(`${this.url}/contact_lists/${id}`);
  }

  getWhatsAppInboxes() {
    return axios.get(`${this.url}/whatsapp_inboxes`);
  }
}

export default new DisparosAPI();
